import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

/**
 * EmbeddedToolbar — shared compact toolbar for editors rendered inside
 * a 420px substrate panel. All embedded editors render their leading
 * controls through this so the panel chrome stays consistent.
 *
 * Slots:
 *   leading: stat badges, mode toggles, anything that lives left of the actions
 *   actions: btn-xs cluster (right-aligned)
 *   search:  { placeholder, value, onChange, onClear }
 *   filters: optional pill row beneath search
 */
export default function EmbeddedToolbar({ leading, actions, search, filters }) {
  return (
    <div className="mb-3 space-y-2">
      {(leading || actions) && (
        <div className="flex items-center gap-2 flex-wrap">
          {leading && <div className="flex items-center gap-2 mr-auto min-w-0">{leading}</div>}
          {actions && <div className="flex items-center gap-2 ml-auto flex-none">{actions}</div>}
        </div>
      )}
      {search && (
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-base-content/50 pointer-events-none" />
          <input
            type="text"
            placeholder={search.placeholder}
            value={search.value || ''}
            onChange={search.onChange}
            className="input input-sm input-bordered w-full pl-8"
          />
          {search.value && search.onClear && (
            <button
              type="button"
              onClick={search.onClear}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content"
            >
              <XMarkIcon className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      )}
      {filters}
    </div>
  );
}

/**
 * EmbeddedSection — section heading + action button used inside a panel.
 */
export function EmbeddedSection({ title, action, children }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-sm font-semibold text-base-content/70">{title}</h2>
        {action}
      </div>
      {children}
    </div>
  );
}
